import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'di-grid-warning-row-renderer',
  templateUrl: './grid-warning-row-renderer.component.html',
  host: {
    class: 'tw:block tw:bg-orange-100 tw:py-2.5 tw:pl-2.5 tw:text-yellow-800',
  },
  standalone: false,
})
export class GridWarningRowRendererComponent implements ICellRendererAngularComp {
  warningMessage: string | undefined;
  params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.setWarningMessage();
  }

  refresh(): boolean {
    this.setWarningMessage();

    return false;
  }

  private setWarningMessage(): void {
    const warning = this.params.data.warning;
    if (!warning || (Array.isArray(warning) && warning.length === 0)) {
      this.warningMessage = undefined;
      return;
    }
    const raw = Array.isArray(warning) ? warning.join('\n') : warning;
    const lines = raw
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    const uniqueLines = [...new Set(lines)];
    this.warningMessage = uniqueLines.length > 0 ? uniqueLines.join('\n') : undefined;
  }
}
